import { defineStore } from "pinia";

export const useAppStore = defineStore("AppStore", {
    state: () => {
        return {
            loading: false,
            openReviewSideBar: false,
            showReviewNextButton: false,
            currentTab: 3,
            order: {},
            orderType: null,
            orderFormData: {}
        }
    }
})
